import { jsxs as l, jsx as o } from "react/jsx-runtime";
import c from "@mui/material/Box";
import t from "@mui/material/CircularProgress";
import { C as p } from "../constants-BT275Ljt.js";
const d = "2.5rem", u = "2rem", i = 7, x = (a) => {
  const { size: m = "medium", sx: n, ...r } = a, s = m === "small" ? u : d;
  return /* @__PURE__ */ l(c, { sx: { position: "relative", mb: "-0.5rem", ...n }, children: [
    /* @__PURE__ */ o(
      t,
      {
        sx: (e) => ({
          color: e.palette.grey[200]
        }),
        size: s,
        thickness: i,
        ...r,
        variant: "determinate",
        value: 100,
        role: "presentation"
      }
    ),
    /* @__PURE__ */ o(
      t,
      {
        sx: (e) => ({
          color: e.palette.grey[500],
          animationDuration: "550ms",
          position: "absolute",
          left: 0
        }),
        disableShrink: !0,
        size: s,
        thickness: i,
        variant: "indeterminate",
        ...r
      }
    )
  ] });
};
x.displayName = `${p}Loader`;
export {
  x as default
};
//# sourceMappingURL=index.js.map
